import {useQuery} from 'react-query'
import {Error500} from '../../modules/errors/components/Error500'
import {RunnerBall} from '../../../components/FormLoader'
import TopBarProgress from 'react-topbar-progress-indicator'
import {fetchLinkedStudentsList} from './api'
import LinkedStudentsTable from './LinkedStudentsTable'

function LinkedStudents({guardianId}: {guardianId: string}) {
  const {data, isLoading, isError, isFetching, refetch} = useQuery(
    ['linked-students', guardianId],
    () => fetchLinkedStudentsList(guardianId),
    {
      refetchOnWindowFocus: false,
    }
  )

  if (isLoading) {
    return <RunnerBall />
  }

  if (isError) {
    return (
      <div className="text-center">
        <Error500 />
      </div>
    )
  }

  return (
    <>
      <LinkedStudentsTable
        studentData={data?.data || []}
        refetchStudentData={refetch}
        guardianId={guardianId}
      />
      {isFetching && <TopBarProgress />}
    </>
  )
}

export default LinkedStudents
